import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { uniqBy } from "lodash";
import React, { useEffect, useState } from "react";
import { productionActions } from "redux/Ldb/actions";

const useGetConvertedUoms = () => {
    const dispatch = useAppDispatch();
    const [convertedUoms, setConvertedUoms] = useState<{ [key: string]: any }[]>([]);
    const [sourceUnit, setSourceUnit] = useState<string>("");
    const [targetUnit, setTargetUnit] = useState<string>("");

    const { fetchingUnitConversions, fetchedUnitConversionsSuccess, convertUnitSuccess } =
        useAppSelector((state) => state.production);

    useEffect(() => {
        dispatch(productionActions.getUnitConversions(sourceUnit, targetUnit));

        return () => {
            dispatch(productionActions.resetGetUnitConversions());
        };
    }, [dispatch, sourceUnit, targetUnit, convertUnitSuccess]);

    useEffect(() => {
        if (Boolean(fetchedUnitConversionsSuccess)) {
            console.log("fetchedUnitConversionsSuccess", fetchedUnitConversionsSuccess);
            setConvertedUoms(fetchedUnitConversionsSuccess?.conversions);
        }
    }, [fetchedUnitConversionsSuccess]);

    return {
        data: convertedUoms,
        isLoading: fetchingUnitConversions,
        setSourceUnit,
        setTargetUnit,
    };
};

export default useGetConvertedUoms;
